import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { addPpiTableRow } from '../actions';
import IconMenu from 'material-ui/IconMenu';
import MenuItem from 'material-ui/MenuItem';
import IconButton from 'material-ui/IconButton';
import IconAdd from 'material-ui/svg-icons/content/add';

function AddTableRow({ tableRowList, tableRowVisibleList, addPpiTableRow }) {
    const hiddenRowList = tableRowList.filter(rowId => !tableRowVisibleList.includes(rowId));

    if (!Object.keys(hiddenRowList).length) return <div> </div>;

    return (
        <IconMenu
            iconButtonElement={
                <IconButton>
                    <IconAdd />
                </IconButton>
            }
            anchorOrigin={{ horizontal: 'left', vertical: 'top' }}
            targetOrigin={{ horizontal: 'left', vertical: 'top' }}
            onChange={(ev, value) => {
                addPpiTableRow(value);
            }}
        >
            {hiddenRowList.map(id => <MenuItem key={id} primaryText={id} value={id} />)}
        </IconMenu>
    );
}

AddTableRow.propTypes = {
    // From connect
    tableRowList: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
    tableRowVisibleList: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
    addPpiTableRow: PropTypes.func.isRequired
};

export default connect(
    ({ ppi: { tableRowList, tableRowVisibleList } = {} }) => ({ tableRowList, tableRowVisibleList }),
    { addPpiTableRow }
)(AddTableRow);



/** WEBPACK FOOTER **
 ** ../src/dash/front/ppi/components/AddTableRow.js
 **/